import titles from "@/store/lang/titles.json";
import { mapGetters, mapActions } from "vuex";
import Success from "../success/Success.vue";
import Tooltip from "../tooltip/tooltip.vue";
import InvisibleRecaptcha from "vue-invisible-recaptcha";
export default {
  name: "CustomerPickup",
  components: {
    Success,
    Tooltip,
    InvisibleRecaptcha,
  },
  data() {
    return {
      logistics_approve: false,
      CustomerPickup: titles.CustomerPickup,
      isActiveFrontDoor: false,
      isActiveRearDoor: false,
      confirmationOfEnoughSpace: false,
      panelOpen: 0,
      confirmContainersStatus: false,
      containersStatusTick: false,
      containersStatusValid: false,
      callDepotValid: false,
      callDepotTick: false,
      confirmCallDepot: false,
      verificationTick: false,
      verificationValid: false,
      pickupQuestionsTick: false,
      rules: {
        requiredRules: [
          (v) => !!v || titles.rulesTitle.deliveryDate.fieldIsRequired,
        ],
      },
      requestForm: {
        event_type: "customer_pickup_request",
        order_number: "",
        order_header_id: "",
        market_code: "",
        container_condition_confirm: "",
        call_depot_confirm: "",
        signature: "",
        additional_info: "",
        CountryCode: "",
      },
      isSubmitSuccessful: false,
      activeStep: 1,
      animation: "animate-in",
      orderDetails: null,
      loading: false,
      orderDetailsTick: false,
      isSubmitting: false,
      logisticsPhone: {
        US: "(800) 768-6080",
        CA: "(800) 925-2515",
      },
    };
  },
  computed: {
    ...mapGetters(["getCountryCode"]),
    progress() {
      var pg = ((this.activeStep - 1) / 4) * 100;

      return pg;
    },
  },
  methods: {
    ...mapActions(["addFormRequest", "getFormRequest"]),
    validateContainersStatusFields() {
      this.containersStatusValid = this.$refs.containersStatusForm.validate();
      this.containersStatusTick = this.containersStatusValid;
      return this.containersStatusValid;
    },
    validateCallDepotFields() {
      this.callDepotValid = this.$refs.callDepotForm.validate();
      this.callDepotTick = this.callDepotValid;
      return this.callDepotValid;
    },
    validateSignatureFields() {
      this.verificationValid = this.$refs.verificationForm.validate();
      this.verificationTick = this.verificationValid;
      return this.verificationValid;
    },
    getPriorPanel(event, idx) {
      event ? event.preventDefault() : null;
      switch (idx) {
        case 2:
          this.priorStep();
          break;
        case 3:
          this.priorStep();
          break;
        case 4:
          this.priorStep();
          break;
        case 5:
          this.priorStep();
          break;
      }
    },
    getNextPanel(event, idx) {
      switch (idx) {
        case 1:
          this.orderDetailsTick = true;
          this.nextStep();
          break;
        case 2:
          !this.validateContainersStatusFields()
            ? this.notValid()
            : this.nextStep();
          break;
        case 3:
          !this.validateCallDepotFields() ? this.notValid() : this.nextStep();
          break;
        case 4:
          this.pickupQuestionsTick = true;
          this.nextStep();
          break;
        case 5:
          if (!this.validateSignatureFields()) {
            this.notValid();
          } else {
            this.submit();
          }
          break;
      }
    },
    submit() {
      this.panelOpen = null;
      this.requestForm.CountryCode = this.getCountryCode;
      this.isSubmitting = true;
      this.addFormRequest({
        data: this.requestForm,
        event_type: this.requestForm.event_type,
      })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.ResponseMetadata &&
            response.data.ResponseMetadata.HTTPStatusCode == 200
          )
            this.isSubmitSuccessful = true;
          this.isSubmitting = false;
        })
        .catch((err) => {
          console.log(err);
          this.isSubmitting = false;
        });
    },
    getRequestForm() {
      this.requestForm = {
        event_type: "customer_pickup_request",
        order_number: this.orderDetails.Order_Number,
        order_header_id: this.orderDetails.Order_Header_Id,
        market_code: this.orderDetails.Market_Code,
        container_condition_confirm: "",
        call_depot_confirm: "",
        signature: "",
        additional_info: "",
        CountryCode: this.getCountryCode,
      };
      this.isSubmitSuccessful = false;
      this.activeStep = 1;
      this.containersStatusTick = false;
      this.callDepotTick = false;
      this.orderDetailsTick = false;
      this.pickupQuestionsTick = false;
      this.verificationTick = false;
    },
    priorStep() {
      this.animation = "animate-out";
      setTimeout(() => {
        this.animation = "animate-in";
        this.activeStep -= 1;
      }, 600);
    },
    nextStep() {
      this.animation = "animate-out";
      setTimeout(() => {
        this.animation = "animate-in";
        this.activeStep += 1;
      }, 600);
    },
    notValid() {
      this.animation = "animate-wrong";
      setTimeout(() => {
        this.animation = "";
      }, 400);
    },
    getStepperContent(step) {
      this.activeStep = step;
      switch (step) {
        case 1:
          this.orderDetailsTick = false;
          break;
        case 2:
          this.containersStatusTick = false;
          break;
        case 3:
          this.callDepotTick = false;
          break;
        case 4:
          this.pickupQuestionsTick = false;
          break;
        case 5:
          this.verificationTick = false;
          break;
      }
    },
    isAllValid() {
      return (
        !(
          this.orderDetailsTick &&
          this.containersStatusTick &&
          this.callDepotTick &&
          this.pickupQuestionsTick &&
          this.requestForm.signature
        ) || this.isSubmitting
      );
    },
    submitted(response) {
      /*resposne will have the reCAPTCHA token.
      If token is null or empty do nothing.*/
      if (!response) return;
      this.getNextPanel(null, this.activeStep);
    },
    /*Get the order details using
    the encrypted query parameter "o"*/
    getOrderDeatils() {
      this.loading = true;
      //console.log("getOrderDeatils is called");
      this.getFormRequest({
        id: this.$route.query.o,
        event_type: this.requestForm.event_type,
      })
        .then((response) => {
          //console.log("API response:", response); 
          if (
            response.data &&
            response.data.statusCode == 200 &&
            response.data.body
          ) {
            const ORDER = response.data.body;
            const IDX = ORDER["OrderLineItems"].findIndex(
              (p) => p.SKU == "HAULING"
            );
            this.orderDetails = {
              Order_Number: ORDER.Order_Number,
              Order_Header_Id: ORDER.order_header_id,
              Quantity: ORDER["OrderLineItems"][IDX].Quantity,
              Market_Code: ORDER.Market_Code,
            };
            this.requestForm.order_number = this.orderDetails.Order_Number;
            this.requestForm.order_header_id = this.orderDetails.Order_Header_Id;
            this.requestForm.market_code = this.orderDetails.Market_Code;
          }

          this.logistics_approve = response.data.body.LOGISTICS_APPROVED;

          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
  },
  mounted() {
    if (this.$route.query.o) this.getOrderDeatils();
  },
};
